import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";

const PHONE_NUMBER = "+919068155122";
const INSTAGRAM = "https://www.instagram.com/karigarihubindia";

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="container-main py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <h3 className="font-heading text-2xl font-semibold mb-2">
              Karigari<span className="text-[#D4AF37]">Hub</span>
            </h3>
            <p className="text-[#D4AF37] text-sm mb-4 font-accent">Premium Hand Embroidery Services</p>
            <p className="text-white/60 max-w-md mb-6 font-body text-sm leading-relaxed">
              Connecting global fashion houses with India's finest hand embroidery artisans. 
              From royal Zardozi to delicate Mukaish — experience centuries of craftsmanship 
              brought to your designs with precision and care.
            </p>
            <div className="accent-line bg-[#D4AF37]" />
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-white/60 hover:text-white text-sm transition-colors">Our Services</Link></li>
              <li><Link to="/how-it-works" className="text-white/60 hover:text-white text-sm transition-colors">How It Works</Link></li>
              <li><Link to="/pricing-guide" className="text-white/60 hover:text-white text-sm transition-colors">Pricing Guide</Link></li>
              <li><Link to="/gallery" className="text-white/60 hover:text-white text-sm transition-colors">Gallery</Link></li>
              <li><Link to="/for-designers" className="text-white/60 hover:text-white text-sm transition-colors">For Designers</Link></li>
              <li><Link to="/custom-bridal-lehengas" className="text-white/60 hover:text-white text-sm transition-colors">Bridal Embroidery</Link></li>
              <li><Link to="/international-orders" className="text-white/60 hover:text-white text-sm transition-colors">International Orders</Link></li>
              <li><Link to="/start-your-project" className="text-white/60 hover:text-white text-sm transition-colors">Start a Project</Link></li>
              <li><Link to="/get-your-lehenga" className="text-white/60 hover:text-white text-sm transition-colors">Get Your Lehenga Made</Link></li>
              <li><Link to="/lehenga-inspiration" className="text-white/60 hover:text-white text-sm transition-colors">Lehenga Inspiration</Link></li>
              <li><Link to="/estimate" className="text-white/60 hover:text-white text-sm transition-colors">Cost Estimator</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Explore</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/60 hover:text-white text-sm transition-colors">About Us</Link></li>
              <li><Link to="/meet-the-karigars" className="text-white/60 hover:text-white text-sm transition-colors">Meet the Karigars</Link></li>
              <li><Link to="/behind-the-craft" className="text-white/60 hover:text-white text-sm transition-colors">Behind the Craft</Link></li>
              <li><Link to="/designers" className="text-white/60 hover:text-white text-sm transition-colors">Designer Magazine</Link></li>
              <li><Link to="/blog" className="text-white/60 hover:text-white text-sm transition-colors">Blog</Link></li>
              <li><Link to="/b2b" className="text-white/60 hover:text-white text-sm transition-colors">B2B / Bulk Orders</Link></li>
              <li><Link to="/global-clients" className="text-white/60 hover:text-white text-sm transition-colors">Global Clients</Link></li>
              <li><Link to="/wedding-planner-guide" className="text-white/60 hover:text-white text-sm transition-colors">For Wedding Planners</Link></li>
              <li><Link to="/track" className="text-white/60 hover:text-white text-sm transition-colors">Track Order</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${PHONE_NUMBER}`} className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors">
                  <Phone className="w-4 h-4" />{PHONE_NUMBER}
                </a>
              </li>
              <li>
                <a href="mailto:karigarihubindia@gmail.com" className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors">
                  <Mail className="w-4 h-4" />karigarihubindia@gmail.com
                </a>
              </li>
              <li>
                <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors">
                  <Instagram className="w-4 h-4" />@karigarihubindia
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Haryana, India<br />Operating Globally</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-wrap gap-4 justify-center mb-6 text-sm">
            <Link to="/legal/privacy" className="text-white/40 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/legal/terms" className="text-white/40 hover:text-white transition-colors">Terms & Conditions</Link>
            <Link to="/legal/shipping" className="text-white/40 hover:text-white transition-colors">Shipping Policy</Link>
            <Link to="/legal/returns" className="text-white/40 hover:text-white transition-colors">Returns & Exchange</Link>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">© {new Date().getFullYear()} KarigariHub. All rights reserved.</p>
            <p className="text-white/40 text-sm font-accent italic">"Where tradition meets innovation"</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
